import { View, type ViewStyle } from "react-native";
import { colors } from "../theme/tokens";

/**
 * Hairline separator. Audit task 2.5.
 *
 * Replaces the dozen-plus inline `<View style={{ height: 1, ... }} />`
 * spread across list/row screens. Defaults to horizontal at 1px in
 * `colors.border`; consumers pass `orientation="vertical"` for column
 * separators, `inset` for indented dividers under iOS-style rows, and
 * `color` to override (rare — most callers want the token).
 */
type Props = {
  orientation?: "horizontal" | "vertical";
  /** Color of the line. Defaults to `colors.border`. */
  color?: string;
  /** Thickness in px. Defaults to 1 (hairline). */
  thickness?: number;
  /** Left inset for horizontal dividers, top inset for vertical. */
  inset?: number;
  style?: ViewStyle;
  testID?: string;
};

export function MoonDivider({
  orientation = "horizontal",
  color = colors.border,
  thickness = 1,
  inset = 0,
  style,
  testID,
}: Props) {
  const isVertical = orientation === "vertical";
  return (
    <View
      testID={testID}
      accessibilityRole="none"
      style={[
        isVertical
          ? {
              width: thickness,
              alignSelf: "stretch",
              backgroundColor: color,
              marginTop: inset,
            }
          : {
              height: thickness,
              alignSelf: "stretch",
              backgroundColor: color,
              marginLeft: inset,
            },
        style,
      ]}
    />
  );
}
